import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'remaining-time',
    imports: [
        TranslateModule
    ],
    templateUrl: './remaining-time.component.html',
    styleUrls: ['./remaining-time.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class RemainingTimeComponent implements OnInit {

    @Input() value: Date;
    @Output() public exipred = new EventEmitter<boolean>(false);

    day = [];
    hour = [];
    minute = [];
    second = [];

    constructor() { }

    ngOnInit(): void {


        // const addDays = Math.floor(this.value / (3600 * 24));
        // const addHours = Math.floor(this.value % (3600 * 24) / 3600);
        // const addMinutes = Math.floor(this.value % 3600 / 60);
        // const addSeconds = Math.floor(this.value % 60);


        // deadline.setTime(deadline.getTime() + (addHours * 60 * 60 * 1000));
        // deadline.setTime(deadline.getTime() + (addDays * 24 * 60 * 60 * 1000));
        // deadline.setTime(deadline.getTime() + (addMinutes * 60 * 1000));
        // deadline.setTime(deadline.getTime() + (addSeconds * 1000));

        let x = setInterval(() => {
            let now = new Date().getTime();
            let t = this.value.getTime() - now;
            let days = Math.floor(t / (1000 * 60 * 60 * 24));
            let hours = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            let minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
            let seconds = Math.floor((t % (1000 * 60)) / 1000);

            if (days > 9) {
                this.day[0] = days.toString()[0];
                this.day[1] = days.toString()[1];
            } else {
                this.day[0] = 0;
                this.day[1] = days.toString()[0];
            }

            if (hours > 9) {
                this.hour[0] = hours.toString()[0];
                this.hour[1] = hours.toString()[1];
            } else {
                this.hour[0] = 0;
                this.hour[1] = hours.toString()[0];
            }

            if (minutes > 9) {
                this.minute[0] = minutes.toString()[0];
                this.minute[1] = minutes.toString()[1];
            } else {
                this.minute[0] = 0;
                this.minute[1] = minutes.toString()[0];
            }
            if (seconds > 9) {
                this.second[0] = seconds.toString()[0];
                this.second[1] = seconds.toString()[1];
            } else {
                this.second[0] = 0;
                this.second[1] = seconds.toString()[0];
            }



            // document.getElementById("demo").innerHTML = days + "d "
            //     + hours + "h " + minutes + "m " + seconds + "s ";
            if (t < 0) {
                clearInterval(x);
                this.exipred.next(true);
            }
        }, 1000);
    }



    // ngOnInit(): void {

    //   this.InitalTimer();

    // }

    // InitalTimer(): any {


    //   this.day = Math.floor(this.value / 1440);
    //   this.hour = Math.floor((this.value - (this.day * 1440)) / 60);
    //   this.minute = Math.round(this.value % 60);
    //   this.second = Math.floor(60);

    //   let timer;

    //   timer = setInterval(() => {

    //     let seconds = Math.floor(60);
    //     let minutes = Math.floor(seconds / 60);
    //     let hours = Math.floor(minutes / 60);
    //     let days = Math.floor(hours / 24);

    //     days = days;
    //     hours = hours %= 24;
    //     minutes = minutes %= 60;
    //     seconds = seconds %= 60;

    //     this.day = days;
    //     this.minute = minutes;
    //     this.hour = hours;
    //     this.second = seconds;
    //   }, 1000);
    // }


    // timeBetweenDates(toDate, timer) {
    //   let dateEntered = toDate;
    //   let now = new Date();
    //   let difference = dateEntered.getTime() - now.getTime();

    //   if (difference <= 0) {

    //     // Timer done
    //     clearInterval(timer);

    //   } else {

    //     let seconds = Math.floor(difference / 1000);
    //     let minutes = Math.floor(seconds / 60);
    //     let hours = Math.floor(minutes / 60);
    //     let days = Math.floor(hours / 24);

    //     days = days;
    //     hours = hours %= 24;
    //     minutes = minutes %= 60;
    //     seconds = seconds %= 60;

    //     this.day = days;
    //     this.minute = minutes;
    //     this.hour = hours;
    //     this.second = seconds;
    //   }
    // }

}
